module.exports = __webpack_public_path__ + "static/media/bg 01.69d676cc.png";